import short from "short-uuid";

export class TicketNumberGenerator {
    static new(): string {
        return short("2346789BCDFGHJKLMNPQRSTVWXY").generate().slice(0, 6);
    }
}
